module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_10X_IDC.70826ce6.png";